// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"3b6fdcaf30b946f84d70","293":"c6da764e168f464108f1","518":"f08fc02c8d368a664dfd","779":"6f812d012a66d86391b4"}[chunkId] + ".js";
};